import { Result } from '@/api/types'
import request from '@/utils/request'
export function setlanguage(language: string): Promise<Result> {
    return request({
        url: '/user/profile/setlanguage',
        method: 'post',
        data: { language },
    })
}
